"use strict";
/**
* TelemetryManager.ts
* Author: CALIB http://aka.ms/CALIB
* Copyright: Microsoft 2017
*
* Record new telemtry events and fires update
*/
Object.defineProperty(exports, "__esModule", { value: true });
var subscribableevent_1 = require("subscribableevent");
var TelemetryManager = /** @class */ (function () {
    function TelemetryManager(_cache) {
        this._cache = _cache;
        this.telemetryEventAdded = new subscribableevent_1.default();
        //noop
    }
    TelemetryManager.prototype.sendTelemetryEvent = function (event) {
        var eventName = event.getEventName();
        var eventData = event.getAttributes();
        var telemetryEnabled = false;
        var clientTelemetryConfig = this._cache.getEcsConfig();
        if (!clientTelemetryConfig) {
            // in the scenario where we have no cached previously ECS config that was successfully fetched in the past,
            // fallback to sending telemetry event
            console.warn('No previously cached ECS telemetry config exists - fallback to sending event');
            telemetryEnabled = true;
        }
        else if (TelemetryManager._containsEcsClientTelemetryConfig(clientTelemetryConfig.config)) {
            var ecsConfig = clientTelemetryConfig.config.ECSCONFIG;
            if (ecsConfig && ecsConfig.ecsClientTelemetry) {
                telemetryEnabled = !!ecsConfig.ecsClientTelemetry[eventName];
            }
        }
        if (telemetryEnabled) {
            this.telemetryEventAdded.fire(eventName, eventData);
        }
    };
    TelemetryManager._containsEcsClientTelemetryConfig = function (config) {
        return !!config && !!config.ECSCONFIG && !!config.ECSCONFIG.ecsClientTelemetry;
    };
    return TelemetryManager;
}());
exports.default = TelemetryManager;
